module.exports = __webpack_public_path__ + "static/media/barbed_wire_clamp.e969aec7.webp";